(() => {
  // Category search: fold the picked product type into the query, the same way
  // Shopify search accepts it (`product_type:"Bullion Coins" AND eagle`).
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-ht-vsearch]');
    if (!form) return;
    const select = form.querySelector('[data-ht-vsearch-type]');
    const input = form.querySelector('input[name="q"]');
    if (!select || !input || !select.value) return;

    const term = input.value.trim();
    const type = `product_type:"${select.value.replace(/"/g, '')}"`;
    event.preventDefault();
    const url = new URL(form.action, window.location.origin);
    new FormData(form).forEach((value, key) => {
      if (key !== 'q') url.searchParams.set(key, value);
    });
    url.searchParams.set('q', term ? `${type} AND ${term}` : type);
    window.location.href = url.toString();
  });

  // Show the picked category again on the search results page.
  const restoreType = () => {
    const q = new URLSearchParams(window.location.search).get('q') || '';
    const match = q.match(/^product_type:"([^"]+)"(?: AND (.*))?$/);
    if (!match) return;
    document.querySelectorAll('[data-ht-vsearch]').forEach((form) => {
      const select = form.querySelector('[data-ht-vsearch-type]');
      const input = form.querySelector('input[name="q"]');
      if (select && [...select.options].some((o) => o.value === match[1])) select.value = match[1];
      if (input) input.value = match[2] || '';
    });
  };

  // Twinkling stars on the highlighted first menu item.
  const addStars = () => {
    const link = document.querySelector('.ht-vh--highlight .m-header__desktop .m-menu__item:first-child > .m-menu__link--main');
    if (!link || link.querySelector('.ht-vh__star')) return;
    const star =
      '<svg viewBox="0 0 10 10" fill="currentColor" aria-hidden="true"><path d="M5 0l1.1 3.9L10 5 6.1 6.1 5 10 3.9 6.1 0 5l3.9-1.1z"/></svg>';
    [1, 2, 3].forEach((n) => {
      const span = document.createElement('span');
      span.className = `ht-vh__star ht-vh__star--${n}`;
      span.setAttribute('aria-hidden', 'true');
      span.innerHTML = star;
      link.appendChild(span);
    });
  };

  const init = () => {
    restoreType();
    addStars();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
